<template>
    <AgeGate/>
</template>

<script>

import AgeGate from "@/components/mixology/AgeGate";

export default {
    name: "agegate-page",
    components: {
        AgeGate
    },
}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/AgeGatePage.vue